import React from "react";
import AllPositionsInPage from "../component/sections/position/AllPosition";
import AddPositionsInPage from "../component/sections/position/AddPosition";
import ViewPositionInPage from "../component/sections/position/ViewPosition";
import EditPositions from "../component/sections/position/EditPositions";
import AllPositionsIndependent from "../component/sections/position/independent/AllPositions";
import EditPositionsIndependent from "../component/sections/position/independent/EditPositions";
import AddPositionsIndependent from "../component/sections/position/independent/AddPositions";
import ViewPositionIndependent from "../component/sections/position/independent/ViewPositions";
import PositionsList from "../component/sections/position/PositionsList";
import ReportPosition from "../component/sections/position/ReportPosition";

const routes = [
  {
    path: "/positions/all/page/:pageID",
    render: () => <AllPositionsInPage />,
    exact: true,
  },
  {
    path: "/positions/add/page/:pageID",
    render: () => <AddPositionsInPage />,
    exact: true,
  },
  {
    path: "/positions/:positionID/view",
    render: () => <ViewPositionInPage />,
    exact: true,
  },
  {
    path: "/positions/:positionID/edit",
    render: () => <EditPositions />,
    exact: true,
  },
  {
    path: "/positions/independent/all/web-site-publisher/:publisherID",
    render: () => <AllPositionsIndependent />,
    exact: true,
  },
  {
    path: "/positions/independent/add/web-site-publisher/:publisherID",
    render: () => <AddPositionsIndependent />,
    exact: true,
  },
  {
    path: "/positions/independent/:positionID/view",
    render: () => <ViewPositionIndependent />,
    exact: true,
  },
  {
    path: "/positions/independent/:positionID/edit",
    render: () => <EditPositionsIndependent />,
    exact: true,
  },
  {
    path: "/positions/list",
    render: () => <PositionsList />,
    exact: true,
  },
  {
    path: "/positions/report-position",
    render: () => <ReportPosition />,
    exact: true,
  },
];

export default routes;
